import React from 'react';

const UserProfile = ({ user, onTopUp }) => {
  return (
    <div className="user-profile">
      <div className="user-info">
        <h3>Welcome, {user.username}!</h3>
        <div className="user-balance">${user.balance.toFixed(2)}</div>
      </div>
      <button 
        className="topup-btn" 
        onClick={onTopUp}
      >
        💳 Top Up
      </button>
    </div>
  );
};

export default UserProfile;